<h2 mat-dialog-title>{{ configuracion.titulo }}</h2>
<div mat-dialog-content>
  @if (configuracion.mensaje) {
    <p class="mensaje">
      {{ configuracion.mensaje }}
    </p>
  }
  <compartido-formulario
    [configuracion]="form.config"
    (valor)="form.valor = $event"
    (valido)="form.valido = $event"
  ></compartido-formulario>
</div>
<div mat-dialog-actions style="display: flex; justify-content: space-evenly">
  @if (configuracion.botonSecundario) {
    <button mat-button color="warn" tabindex="-1" (click)="dialogRef.close(undefined)">
      {{ configuracion.botonSecundario }}
    </button>
  }
  <button
    mat-flat-button
    color="primary"
    tabindex="-1"
    [disabled]="!form.valido"
    (click)="dialogRef.close(form.valor)"
  >
    {{ configuracion.botonPrincipal }}
  </button>
</div>
